var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTrace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 349 343",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-766.28,-371.707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M831.74,410.352L766.78,550.612L928.843,713.574L995.376,576.911L831.74,410.352Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.843,713.574L939.685,710.35L1007.15,573.686",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.376,576.911L1007.15,573.686",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.15,573.686L869.296,430.693L1049.93,556.523L1060.36,554.724L964.626,400.259L1103.87,540L1114.47,536.049L954.261,372.207L937.898,378.141L1029.43,527.931L849.966,404.336",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.74,410.352L849.966,404.336",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.639,443.339L937.898,378.141",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.84,675.6L984.112,692.467",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.112,692.467L1049.93,556.523",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.112,692.467L992.563,689.949",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.36,554.724L992.563,689.949",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.03,651.113L1035.72,673.298L1103.87,540L1114.47,536.049L1046.53,670.181L1035.72,673.298",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTrace);
export default __webpack_public_path__ + "static/media/LogoTrace.6eb209fdaae49690472760b9e9c2edbb.svg";
export { ForwardRef as ReactComponent };